import React from 'react';
import {SkeletonBlock} from '@aboutyou/ui-components';

export const BasketInfoSkeleton = () => {
  return <SkeletonBlock $width="100%" $height="120px" />;
};
